module.exports = __webpack_public_path__ + "img/passport-do.d15d5664.png";